import React from 'react';
import { Container } from '@infoods/lifebase-ui';

import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';

import classes from './NgzScanIqHome.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { CustomerSuccessWidget } from './components/CustomerSuccessWidget/CustomerSuccessWidget';
import { CustomerAnalyticsWidget } from './components/CustomerAnalyticsWidget/CustomerAnalyticsWidget';
import { RequiredAttentionWidget } from '../../containers/RequiredAttentionWidget/RequiredAttentionWidget';
import { SOLUTION_TYPE } from '../../../shared/constants/user-info/solutionType';
import { InsightsWidget } from '../../containers/InsightsWidget/InsightsWidget';
import { BannerWidget } from '../../containers/BannerWidget/BannerWidget';

const NgzScanIqHome = () => {
  return (
    <Container>
      <div className={classes.content}>
        <div className={classes.row}>
          <BannerWidget solutionType={SOLUTION_TYPE.SCAN_IQ} />
          <CustomerSuccessWidget />
        </div>
        <div className={classes.row}>
          <CustomerAnalyticsWidget />
          <InsightsWidget solutionType={SOLUTION_TYPE.SCAN_IQ} />
        </div>
        <RequiredAttentionWidget
          solutionType={SOLUTION_TYPE.SCAN_IQ}
          unreadScansTableMode="SCAN_IQ"
          paymentIssueTableMode="SCAN_IQ"
          titleIcon={<EditNoteOutlinedIcon fontSize="small" />}
        />
      </div>
    </Container>
  );
};

angularizeWithProviders(NgzScanIqHome, 'ngzScanIqHome', {});
